module.exports = __webpack_public_path__ + "static/media/galerija_2017 (26).ad7cd628.jpg";